import { Pivot } from './Engine/Pivot';
import { DomainEngine } from './Engine/DomainEngine';
import { FilterEngine } from './Engine/FilterEngine';
export class Engine {
    constructor(dataset) {
        this._dataset = dataset;
    }
    get dataset() {
        return this._dataset;
    }
    pivot(model, query) {
        return new Pivot(this, query);
    }
    domain(model, query) {
        return new DomainEngine(this, query);
    }
    filter(model, query) {
        return new FilterEngine(this, query);
    }
}
